import * as React from 'react';
import { lazyInject } from '../../../services/inversify';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { IDs } from '../../../helpers/IDs';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';

interface HWKListeProps extends React.ClassAttributes<any> {
    data: any;
    standortSelected: any;
}

interface HWKListeState {
    dummy?: any;
}

export class HWKListe extends React.Component<HWKListeProps, HWKListeState> {

    constructor(props: any) {
        super(props);
        this.state = {
        };
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    render(): JSX.Element {
        return (
            <div>
                <WFormsTableWrapper
                    entity={IDs.ENT_HWK}
                    module={IDs.MOD_ETOOL_ADMIN}
                    actions={['add', 'edit', 'delete']}
                    customClass={'Custom-ETA'}
                    formLayout={'flowV2'}
                    onSaveDone={() => this.triggerService.fire('admin_reload', IDs.ENT_HWK)}
                    showColumnsHelp={true}
                />
            </div>
        );
    }
}
